import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Layout,
  theme,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  Checkbox,
  Spin,
  Col,
} from "antd";
import { useNavigate, Link } from "react-router-dom";

//PROJECT IMPORTS
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TextArea from "antd/lib/input/TextArea";
import TopContent from "../../../components/layouts/TopContent";
import appStatic from "../../../config/appStatic";
import appLabel from "../../../config/appLabel";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import definedApi from "../../../services/definedApi";
import { newGlAccountAction } from "../../../redux/actions";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const NewGLA0400 = (props) => {
  //DECLARED VARIABLES
  const {
    userData,
    onSelectItemAction,
    rightBtn,
    rightAction,
    getGlListAction,
    newGlAccountAction,
  } = props;
  const { session } = userData;

  const navigate = useNavigate();
  const { newGLMappingItems, statusData } = appStatic;

  const dispatch = useDispatch();
  const [financialActivityData, setFinancialActivityData] = useState([]);
  const [accountData, setAccountData] = useState([]);
  const [accountingDetail, setAccountingDetail] = useState({});
  const [manualEntriesAllowed, setManualEntriesAllowed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getTemplate();
    //ACTIVATE SAVE RIGHTSIDEBAR ACTION
    // dispatch({
    //   type: cnt.RIGHT_SAVE_BTN,
    // });
  }, []);

  function onCancel() {
    navigate("/gla0400", { replace: false });
  }

  function getTemplate() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.GlMappingTemplate, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = res;
        setAccountingDetail(objList?.glAccountOptions);
        let tempFinancialActivity = [];

        objList?.financialActivityOptions?.forEach((element) => {
          tempFinancialActivity.push({
            value: element.id,
            label: appStatic.financialActivityLabelMapping[element.name] || element.name,
            mappedGLAccountType: element.mappedGLAccountType,
          });
        });

        setFinancialActivityData(tempFinancialActivity);
      }
    });
  }

  function onSelectFinancialActivity(key, objParam) {
    let tempAccount = [];

    switch (objParam?.mappedGLAccountType?.toLowerCase()) {
      case "asset":
        accountingDetail?.assetAccountOptions?.forEach((element) => {
          tempAccount.push({
            value: element.id,
            label: element.name,
          });
        });
        break;
      case "liability":
        accountingDetail?.liabilityAccountOptions?.forEach((element) => {
          tempAccount.push({
            value: element.id,
            label: element.name,
          });
        });
        break;
      case "equity":
        accountingDetail?.equityAccountOptions?.forEach((element) => {
          tempAccount.push({
            value: element.id,
            label: element.name,
          });
        });
        break;

      default:
        break;
    }

    setAccountData(tempAccount);
  }

  const handleManuelEntriesAllowed = (e) => {
    setManualEntriesAllowed(e.target.checked);
  };

  const onSubmit = (formValues) => {
    const body = {
      ...formValues,
      method: "POST",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      definedApi.NewGlMapping,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, appLabel.newGLCreatedMsg);
          navigate("/gla0400");
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/gla0400");
          setIsLoading(false);
        },
      }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent pageTitle={appLabel.newGLMapping} pageItems={newGLMappingItems} />
      <Spin spinning={isLoading} size="large">
        <Card
          title={
            <Title level={4} style={{ color: "#000" }}>
              {appLabel.generalInfo}
            </Title>
          }
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form layout="vertical" onFinish={onSubmit}>
            <Card
              style={{
                marginBottom: "3%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
              bordered
            >
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Form.Item
                    name="financialActivityId"
                    label={<Text strong>{appLabel.financialActivity}</Text>}
                    rules={[
                      {
                        required: true,
                        message: "Required Field",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Please Select an option"
                      options={financialActivityData}
                      showSearch
                      onChange={onSelectFinancialActivity}
                    />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    name="glAccountId"
                    label={<Text strong>{appLabel.account} </Text>}
                    rules={[
                      {
                        required: true,
                        message: "Required Field",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Please Select an option"
                      options={accountData}
                      showSearch
                    />
                  </Form.Item>
                </Col>

                <div style={{ width: "30vh" }}></div>
              </Row>
            </Card>
            <Form.Item>
              <Row>
                {BOM.HasPermission("CREATE_FINANCIALACTIVITYACCOUNT") && (
                  <CustomButton
                    content="Submit"
                    style={{
                      width: "10%",
                      marginLeft: "auto",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    htmlType="submit"
                    backgroundColor="#92428B"
                    colorText="white"
                    hoverBackground="#AD4EA7"
                  />
                )}
                <CustomButton
                  content="Cancel"
                  style={{
                    width: "10%",
                    marginLeft: "1%",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  backgroundColor="#fff"
                  colorText="black"
                  hoverBackground="#F5F5F5"
                  onClick={onCancel}
                />
              </Row>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { newGlAccountAction };

export default connect(mapStateToProps, mapDispatchToProps)(NewGLA0400);
